import { useNavigate } from "react-router-dom";

import "./Button01.css";

import icon from "../../img/logo/favicon.png";

const Button01 = () => {
  const navigate = useNavigate();

  return (
    <div className="Button01">
      <button type="button" onClick={() => navigate("/contact")}>
        <div className="Button01-icon">
          <img src={icon} alt="icon" />
        </div>

        <p> Request an Invite</p>

        <div className="Button01-bg"></div>
      </button>
    </div>
  );
};

export default Button01;
